import NotFoundImage from '@assets/images/DomainError.png'
import { KUDOS } from '@globals/paths/useDocumentTitle'
import { colors } from '@globals/themes/defaultTheme'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PageKudosTitleImage from '@shared/PageKudosTitleImage'
import { T, useT } from '@transifex/react'
import { useEffect } from 'react'
import { Link as RouterLink } from 'react-router'
import { ButtonStyles, StackStyles } from './RoutingStyles'

type NotFoundRouteProps = {
  message?: React.ReactNode
  to?: string
  buttonText?: React.ReactNode
}

const NotFound: React.FC<NotFoundRouteProps> = ({
  message,
  to,
  buttonText = <T _str="Back to home" />,
}) => {
  const t = useT()
  useEffect(() => {
    document.title = `${KUDOS} - Oops, not found!`
  }, [])

  return (
    <Stack useFlexGap spacing={3} sx={StackStyles}>
      <PageKudosTitleImage />
      <img src={NotFoundImage} alt={t('Person looking through a pair of binoculars')} />
      <Typography
        variant="h1"
        sx={{
          textAlign: 'center',
        }}>
        {message ? message : <T _str="Page not found" />}
      </Typography>
      <Typography sx={{ color: colors.grayMedium, textAlign: 'center' }}>
        <T _str="The page you’re looking for doesn’t exist or may have moved." />
      </Typography>
      {to && buttonText && (
        <Button
          id="btnNotFoundRoute"
          variant="contained"
          component={RouterLink}
          sx={ButtonStyles}
          to={to}>
          {buttonText}
        </Button>
      )}
    </Stack>
  )
}

export default NotFound
